import axios from "axios";
console.log(
  process.env.REACT_APP_API_BASE_URL,
  "process.env.REACT_APP_API_BASE_URL"
);
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL.trim()
  : "http://localhost:7070";

const axiosClient = axios.create({
  baseURL: `${apiBaseUrl}/api`,
});

// Add request interceptor
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor
axiosClient.interceptors.response.use(
  (response) => response, // Pass successful responses
  (error) => {
    const { response } = error;

    if (response?.status === 401) {
      // ["token", "userId", "userID", "isLogin"].forEach((key) =>
      //   localStorage.removeItem(key)
      // );
      localStorage.clear();
      // alert("Your session has expired. Please log in again.");
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
